module.exports = __webpack_public_path__ + "img/2_uk.ff573653.svg";